import styles from "./styles.scss";
import { FC } from "react";
import clsx from "clsx";
import { Spinner } from "@/components";
import { LoaderProps } from "./types";

export const Loader: FC<LoaderProps> = ({ className, diameter = 40 }) => (
  <div className={clsx(styles.loaderWrapper, className)}>
    <Spinner diameter={diameter} />
  </div>
);
